import { API_PATHS } from '../../helpers/endpoints';
import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';

export default {
  getVehicle: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.VEHICLES_SEARCH}?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getVehicleGroups: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.VEHICLE_GROUPS_SEARCH}?&${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  getVehicleBrands: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.VEHICLE_BRANDS_SEARCH}?`,
      });
      return response._embedded.vehicleBrandResponseDtoList;
    } catch (error) {
      throw error;
    }
  },

  getVehicleModels: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.VEHICLE_MODELS_SEARCH}?`,
      });
      return response._embedded?.vehicleModelResponseDtoList;
    } catch (error) {
      throw error;
    }
  },

  editVehicle: async (data, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.VEHICLES}/${id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editVehicleGroups: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.VEHICLE_GROUPS}/${data.id}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addVehicle: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.VEHICLES}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addVehicleGroups: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.VEHICLE_GROUPS}`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeVehicleGroupStatus: async (data) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.VEHICLE_GROUPS}/update-status`,
        data,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteVehicle: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.VEHICLES}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteVehicleGroups: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.VEHICLE_GROUPS}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  changeVehicleStatus: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.VEHICLES}/update-status`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCourierApplicationStatus: async (payload, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PATCH,
        url: `${API_PATHS.COURIERS_APPLICATIONS_STATUS_UPDATE}/${id}/status`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
